import { createHttpEndpoint } from '../../utils'

/**
 * Retrieve Client profile
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/after-sale-client-api/definition#tag/profile/operation/retrieveClientProfile}
 */
export const getProfile = createHttpEndpoint({
  method: 'GET',
  operationId: 'retrieveClientProfile',
  path: '/bm/client/profile',
})

/**
 * Update Client profile
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/after-sale-client-api/definition#tag/profile/operation/updateClientProfile}
 */
export const putProfile = createHttpEndpoint({
  method: 'PUT',
  operationId: 'updateClientProfile',
  path: '/bm/client/profile',
})
